/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React from 'react';

import {
  VideoImage,
  VideoInfos,
  VideoInfosContent,
  VideosInfosText,
  VideosInfosTitle,
} from './styled';

export default function VideoInformations({
  details,
}: {
  details: { title?: string; description?: string; thumb?: { uri: string } };
}) {
  return (
    <>
      <VideoInfos>
        <VideoImage source={details?.thumb} />
        <VideoInfosContent>
          {/* <VideosInfosText>{details?.title}</VideosInfosText> */}
          <VideosInfosTitle>{details?.title}</VideosInfosTitle>
        </VideoInfosContent>
      </VideoInfos>
    </>
  );
}
